import { render } from "./SetorTabungan.vue?vue&type=template&id=1508c65d"
import script from "./SetorTabungan.vue?vue&type=script&lang=js"
export * from "./SetorTabungan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__